import * as Types from '../../common/types/graphql-types';

import { gql } from '@apollo/client';
import { BaseProductFragmentDoc } from '../fragments/ProductFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProductsQueryVariables = Types.Exact<{
  type: Types.ProductType;
  interval?: Types.InputMaybe<Types.PriceInterval>;
  page?: Types.InputMaybe<Types.Scalars['String']>;
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductPage', results?: Array<{ __typename?: 'Product', id: string, name: string, type: Types.ProductType, features: Array<string>, calloutText?: string | null | undefined, prices: Array<{ __typename?: 'Price', id: string, amount: number, interval?: Types.PriceInterval | null | undefined }> }> | null | undefined } };


export const GetProductsDocument = gql`
    query GetProducts($type: ProductType!, $interval: PriceInterval, $page: String, $pageSize: Int) {
  products(
    input: {type: $type, interval: $interval, page: $page, pageSize: $pageSize}
  ) {
    results {
      ...BaseProduct
    }
  }
}
    ${BaseProductFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      interval: // value for 'interval'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;